import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Z_INDEX } from '../../utils/common'
import { Element } from '../html/element'
import classes from './index.module.scss'

export const Popup = ({
  appendStyle,
  children,
  appendStyleContent,
  appendStyleModal,
}) => {
  const [modalElement, setModalElement] = useState(null)

  useEffect(() => {
    const newModal = document.createElement('div')
    document.body.appendChild(newModal)
    setModalElement(newModal)

    return () => {
      document.body.removeChild(newModal)
    }
  }, [])

  return (
    <>
      {modalElement &&
        createPortal(
          <Element
            style={{
              fontSize: 12,
              zIndex: Z_INDEX.MODAL,
              ...appendStyle,
            }}
            className={classes.overlay}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={classes.modal} style={{ ...appendStyleModal }}>
              <Element
                style={{
                  ...appendStyleContent,
                }}
              >
                {children}
              </Element>
            </div>
          </Element>,
          modalElement,
        )}
    </>
  )
}

Popup.propTypes = {
  children: PropTypes.node.isRequired,
  appendStyle: PropTypes.object,
  appendStyleContent: PropTypes.object,
}

Popup.defaultProps = {
  appendStyle: {},
  appendStyleContent: {
    padding: '20px',
    backgroundColor: '#F3F3F3',
    width: 480,
    borderRadius: '4px',
  },
}
